import React, {useState, useEffect} from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import Message from "../components/Message";
import Loader from "../components/Loader";
import FormContainer from "../components/FormContainer";
import { login } from "../actions/userActions";


function LogininScreen() {
    const { t } = useTranslation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { redirect: redirectParam } = useParams();

    const normalizeRedirect = (value) => {
      if (!value) return '/';
      const decoded = decodeURIComponent(value);
      return decoded.startsWith('/') ? decoded : `/${decoded}`;
    };

    const queryRedirect = new URLSearchParams(location.search).get('redirect');
    const pathRedirect = redirectParam;
    const redirect = normalizeRedirect(queryRedirect || pathRedirect);

    const userLogin = useSelector(state => state.userLogin);
    const { loading, error, userInfo } = userLogin;


    useEffect(() => {
        if (userInfo) {
            navigate(redirect);
        }
    }, [navigate, userInfo, redirect]);


    function submitHandler(e) {
        e.preventDefault();
        dispatch(login(email, password));
    }

    
  return (
    <FormContainer>
      <h1>{t('login.title')}</h1>
      {error && <Message variant="danger">{error}</Message>}
      {loading && <Loader />}
      <Form onSubmit={submitHandler}>
        <Form.Group controlId="email">
          <Form.Label>{t('login.email')}</Form.Label>
          <Form.Control
            type="email"
            placeholder={t('login.emailPlaceholder')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId="password">
          <Form.Label>{t('login.password')}</Form.Label>
          <Form.Control
            type="password"
            placeholder={t('login.passwordPlaceholder')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Row className="py-2">
          <Col className="text-end">
            <Link to="/forgot-password">{t('login.forgotPassword')}</Link>
          </Col>
        </Row>

        <Button type="submit" variant="primary" className="mt-2">
          {t('login.signIn')}
        </Button>
      </Form>

      <Row className="py-3">
        <Col>
          {t('login.newCustomer')} <Link to={redirect ? `/register?redirect=${redirect}` : '/register'}>{t('login.register')}</Link>
        </Col>
      </Row>
    </FormContainer>
  );
}





export default LogininScreen;